import {until} from 'lit-html/directives/until';
import {permissions,} from '@modules/constants-enumerate';

const lowerLevelAdminsPermissions = [
  permissions.ROSTER_FULL,
  permissions.ROSTER,
  permissions.EXPORT_ALL,
  permissions.ALL
];

export default (ctx, html) => {
  let label;
  if (ctx.disableExportLink) {
    label = html`
      <div class="spinner-border mr-3" role="status">
        <span class="sr-only">Downloading...</span>
      </div>
    `;
  } else {
    label = until(ctx.__('<tt-4jVgbqQR>', 'Download Existing Roster'));
  }

  return html`
    <div class="d-flex justify-content-end">
      <auth-context @keypress="${(e) => (e.key === 'Enter') ? ctx.exportAll() : null}" show-on-auth .permissions="${lowerLevelAdminsPermissions}">
        <button type="button" class="btn btn-link py-0" @click="${ctx.exportAll}" .disabled="${ctx.disableExportLink}">
          <i class="ai ai-download"></i> ${label}
        </button>
      </auth-context>
      
      <auth-context @keypress="${(e) => (e.key === 'Enter') ? ctx.getRosterTemplate() : null}" show-on-auth .permissions="${lowerLevelAdminsPermissions}">
        <button type="button" class="btn btn-link py-0" @click="${ctx.getRosterTemplate}" .disabled="${ctx.disableExportLink}">
          <i class="ai ai-download"></i> ${until(ctx.__('<tt-wOBY86cv>', 'Download Roster Template'))}
        </button>
      </auth-context>
    </div>
  `;
};
